module.exports = __webpack_public_path__ + "img/symbol_9.4b911426.png";